export default __webpack_public_path__ + "static/force-usa_cover-big_1-e927c178343fda9480ec65f97bb39132.webp";